import React, { Component } from "react";

import { Table, DatePicker, Input, Button } from "antd";

import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpUrl, httpPost } from "../../api/httpClient";
import { formatDate, startDateFormat, endDateFormat, amountFormat } from "../../util";
import EventRegist from "./EventRegist";
import EventModify from "./EventModify";
import string from "../../string";
import SelectBox from "../../components/common/SelectBox";
import EventReward from "./EventReward";

const Search = Input.Search;
const { RangePicker } = DatePicker;

class EventRewardList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchType: string.defaultSearchTypeCode[0],
      searchText: '',
      eventRewardList: [],
      pagination: {
        total: 0,
        current: 1
      },
    };
  }

  componentDidMount() {
    this.getEventRewardList();
  }
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getEventRewardList());
  };

  initialLoad = () => {
    this.setState({
      eventRewardList: [],
      pagination: {
        total: 0,
        current: 1
      }}, () => {
        this.getEventRewardList();
      })
  }
  reload = () => {
    this.getEventRewardList();
  }
  getEventRewardList = () => {
    let pageNum = this.state.pagination.current;
    let userId = '';
    let userName = '';
    let userTel = '';
    if (this.state.searchType == 'ID') userId = this.state.searchText;
    else if (this.state.searchType == 'NAME') userName = this.state.searchText;
    else if (this.state.searchType == 'PHONE') userTel = this.state.searchText;
    httpGet(httpUrl.getEventRewardList,[10,pageNum,userId, userName, userTel],{}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        eventRewardList: res.data.eventRewards,
        pagination,
      });
    });
  };
  render() {
    const { eventRewardList } = this.state;
    const coinList = reactLocalStorage.getObject("coinList");

    const columns = [
      {
        title: "이벤트번호",
        dataIndex: "eventIdx",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "이벤트제목",
        dataIndex: "eventTitle",
        className: "support-column fs-15 lh-21",
      },
      {
        title: "지급내용",
        dataIndex: "title",
        className: "support-column fs-15 lh-21",
      },
      {
        title: "받은사람",
        dataIndex: "userId",
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => (
          <div>{row.userId+"("+row.userName+","+row.userTel+")"}</div>
        ),
      },
      {
        title: "지급코인",
        dataIndex: "coinType",
        className: "support-column-number fs-15 lh-21",
        render: (data) => (
          <div>{coinList.find((coin) => coin.coinType === data).name}</div>
        ),
      },
      {
        title: "지급수량",
        dataIndex: "amount",
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => <div>{amountFormat(data, row.coinType)}</div>,
      },
      {
        title: "지급일",
        dataIndex: "createDate",
        className: "support-column-number fs-15 lh-21",
        render: (data) => <div>{formatDate(data)}</div>
      },

    ];

    return (
      <div>
        <div
          style={{
            fontSize: "20px",
            color: "#000",
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "bold",
          }}>
          이벤트 보상 지급목록
      </div>
        <div className="wrapper mt-35 width-1240" />
          <div className="flex-row flex-center" style={{paddingBottom: '10px'}}>
            <label htmlFor="searchType">검색 대상&nbsp;</label>
            <SelectBox
              value={this.state.searchType}
              code={string.defaultSearchTypeCode}
              codeString={string.defaultSearchTypeString}
              onChange={(value) => {
                  this.setState({
                    searchType: value,
                  });
              }}
            />
            <Search
              placeholder={`검색어를 입력해주세요.`}
              enterButton="검색"
              allowClear
              onSearch={(value) => {
                this.setState({searchText: value}, ()=>this.reload())
              }}
              style={{ width: 400 }}
            />
          </div>
        <Table
          rowKey={(record) => record.idx}
          rowClassName={(record) => (record.deleted ? "gray" : "")}
          dataSource={eventRewardList}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default EventRewardList;
